import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTraining: BlogMetaData = {
  title: 'トイレトレーニングの進め方｜始め方・5ステップと年齢別の目安【モンテッソーリ】',
  description:
    'トイレトレーニングの進め方を、始め方・準備・5ステップ・年齢別の目安までモンテッソーリの視点でやさしく解説。いつから始める？のサインや、うまくいかない時・夜の考え方への入口もまとめた完全ガイドです。',
  thumbnailUrl: '/img/blog-toilet-training.webp',
  filePath: buildBlogFilePath('toilet-training'),
  category: BLOG_CATEGORY.PARENTING,
};
